import { render, staticRenderFns } from "./codicesblocco.vue?vue&type=template&id=93239902"
import script from "./codicesblocco.vue?vue&type=script&lang=js"
export * from "./codicesblocco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93239902')) {
      api.createRecord('93239902', component.options)
    } else {
      api.reload('93239902', component.options)
    }
    module.hot.accept("./codicesblocco.vue?vue&type=template&id=93239902", function () {
      api.rerender('93239902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/codicesblocco.vue"
export default component.exports